export default __webpack_public_path__ + "static/media/eye_open.36b129bb.svg";